import 'core-js/es6/promise'; // For IE 11 support
import AbacusClientUtils from '@homeaway/abacus-client-utils';
import React from 'react';
import ReactDOM from 'react-dom';
import {ApolloClient} from 'apollo-client';
import {HttpLink} from 'apollo-link-http';
import {InMemoryCache} from 'apollo-cache-inmemory';
import {TrackFocus} from '@homeaway/a11y-tools';
import {createStore, combineReducers} from 'redux';
import getCurrentScriptPath from '@homeaway/current-script-path';
import Root from './Root';

import {toasterReducers} from './components/molecules/baseline/baseline';
import {VRBEX} from '../server/utils/vrbex';

const store = createStore(
    combineReducers({
        toaster: toasterReducers,
    })
);

/**
 * Main client-side entry point. This is not used during
 * server-side rendering, only after the javascript bundle
 * has been loaded into the browser.
 */

const trackFocus = new TrackFocus();
trackFocus.bindEvents();

// Create GraphQL client
const client = new ApolloClient({
    // Please note, there is a `apollo-link-batch-http` lib that can batch requests.
    // That doesn't solve issues where a child component is rendered after data comes
    // back from a parent component, however.
    link: new HttpLink({
        credentials: 'same-origin',
        headers: {
            'X-CSRF-Token': window.ha.crumb,
            'x-api-version': '2.4',
            'x-homeaway-site':
                typeof window.__SITE_CONTEXT__ !== 'undefined'
                    ? window.__SITE_CONTEXT__.name
                    : '',
            'x-vrbex-native':
                typeof window.__VRBEX_NATIVE_EXPERIENCE__ !== 'undefined'
                    ? window.__VRBEX_NATIVE_EXPERIENCE__
                    : false,
            'x-vrbo-postbooking-experience':
                typeof window.__POSTBOOKING_EXPERIENCE__ !== 'undefined' &&
                window.__POSTBOOKING_EXPERIENCE__
                    ? VRBEX
                    : false,
        },
        uri: '/traveler/trips/graphql',
    }),
    // Initialize cache with server side rendered data that was embedded in the page
    cache: new InMemoryCache().restore(window.__APOLLO_STATE__),
    // TODO: Remove this prop once we update react to latest version & start using hooks.
    ssrForceFetchDelay: 1,
});

AbacusClientUtils.initialize(window.abacus);

// Let webpack know where to load files from in production envs.
// This is primarily for code-splitting scenarios and for images.
if (!module.hot) {
    __webpack_public_path__ = getCurrentScriptPath(); // eslint-disable-line
}

ReactDOM.hydrate(
    <Root
        abacus={window.abacus}
        client={client}
        store={store}
        siteContext={window.__SITE_CONTEXT__}
        isVrbex={window.__POSTBOOKING_EXPERIENCE__}
        isVrbexNative={window.__VRBEX_NATIVE_EXPERIENCE__}
        isConfirmationToTID={window.__CONFIRMATION_TO_TID_EXPERIENCE__}
    />,
    document.getElementById('root')
);
